'use client';

export { NewsletterForm } from './ui/newsletter-form';
